import { render, staticRenderFns } from "./HistoryMoviment.vue?vue&type=template&id=2d8a32cc&"
import script from "./HistoryMoviment.vue?vue&type=script&lang=js&"
export * from "./HistoryMoviment.vue?vue&type=script&lang=js&"
import style0 from "./HistoryMoviment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports